'use strict';

angular.module('shiftTraderApp')
  .directive('userLink', function () {
    return {
      template: '<div style=\'display:inline;\'><span class=\'generic_user_name\' ng-if=\'::!link\'><span ng-bind=\'::userText\'></span></span>' +
                '<a class=\'generic_user_name\' ng-if=\'::link\' href=\"#/profile/{{::user.id}}\"><span ng-bind=\'::userText\'></span></a></div>',
      restrict: 'A',
      scope: {
        user:'=userLink',
        upper:'=upper',
        abbrev:'=abbrev',
        link: '=link',
        initials:'='
      },
      replace:true,
      controller: ['$scope', '$filter', function($scope, $filter) {
        function init() {
          $scope.userText = $scope.user.name;

          if ($scope.upper) {
            $scope.userText = $filter('uppercase')($scope.userText);
          }
          if ($scope.abbrev) {
            $scope.userText = $filter('abbreviatedName')($scope.userText);
          }
          if ($scope.initials === true || $scope.initials === 'true') {
            $scope.userText = $scope.user.first_name[0] + $scope.user.last_name[0];
          }

          deregisterWatch();
        }

        var deregisterWatch = $scope.$watch('user', function() {
          if (!lodash.isUndefined($scope.user) && !lodash.isNull($scope.user)) {
            init();
          }
        });
      }]
    };
  });
